export type PreviewPage = {
  image: string
  tag: string
  title: string
  text: string
}

export const previewPages: PreviewPage[] = [
  {
    image:
      'https://cdn.magicpatterns.com/uploads/muiu78uiLMFjrWHAJeiMCp/Captura-de-pantalla-2026-09-24-a-la_s_-8.25.33_p._m..webp',
    tag: 'Attività visuale',
    title: 'Conta, Collega e Scopri i Numeri',
    text: 'Ogni lezione arriva con esempi visuali, attività operative, esercizi e verifiche già pronti.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/gbwmMykYua74C7YUoUYruH/Captura-de-pantalla-2026-09-24-a-la_s_-8.27.33_p._m..webp',
    tag: 'Passo dopo passo',
    title: 'Prima e Dopo',
    text: 'La retta numerica guida gli alunni a riconoscere predecessore e successore.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/oq8SjpN3zpFXiSTqMTuKoT/Captura-de-pantalla-2026-09-24-a-la_s_-8.29.30_p._m..webp',
    tag: 'Verifica pronta',
    title: 'Conta Tutto: Verifica 1–10',
    text: 'Conta, scrivi e collega: una verifica completa con autocontrollo per la classe.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/aVZXJuj4ZJfdFHKZbUD5FE/Captura-de-pantalla-2026-09-24-a-la_s_-8.30.19_p._m..webp',
    tag: 'Problemi illustrati',
    title: 'Problemi Visuali',
    text: 'Addizioni e sottrazioni lette direttamente dal disegno: aggiungo o tolgo?',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/tVdr2DN4rhcV4rmCbQxqBD/Captura-de-pantalla-2026-09-24-a-la_s_-8.32.09_p._m..webp',
    tag: 'Scheda stampabile',
    title: 'La Grande Sfida dei Numeri!',
    text: 'Sei sfide graduate per ripassare tutto: stampa e distribuisci.',
  },
]
